import { useEffect } from "react";
import { useSelector } from "react-redux";
import style from './not-authorized-popup.module.scss';
import notAuthImg from '../../../images/not-auth.png'
import hyphen from "../../../utils/hyphen";
import { getPoints } from "../../../utils/getPoints";
export const NotAuthorizedPopup = ({ title, close }) => {
  const lang = useSelector(state => state.app.currentLang);
  const langName = useSelector(state => state.app.currentLangName);
  const gifts = useSelector(state => state.game.gameShop?.gifts);
  const playPrice = useSelector(state => state.game.gameWheel?.settings?.playPrice);

  useEffect(() => {
    document.body.classList.add("noscroll");
    return () => {
      document.body.className = document.body.className.replace("noscroll", "");
    }
  }, []);

  let minPrice = 0;
  if (Array.isArray(gifts) && gifts.length > 0) {
    minPrice = Number(gifts[0].price);
    for (let i = 0; i < gifts.length; i++) {
      const giftPrice = Number(gifts[i].price);
      if (minPrice > giftPrice) minPrice = giftPrice;
    }
  }
  if(playPrice && isNaN(playPrice) && minPrice > playPrice) minPrice = Number(playPrice);
  return (
    <div className={style["not-authorized-popup"]}>
      <div className={style["not-authorized-popup__back"]} onClick={close}></div>
      <div className={style["not-authorized-popup__wrap"]}>
        <div className={style["not-authorized-popup__box"]}>
          <div className={style["not-authorized-popup__head"]}>
            {lang.notAuthorizedPopup.header+ " " + hyphen(title.toLowerCase()) + '?'}
          </div>
          <div className={style["not-authorized-popup__body"]}>
            <p>{lang.notAuthorizedPopup.text1}</p>
            <p>{lang.notAuthorizedPopup.text2 + ' ' + minPrice + ' ' + getPoints(langName, minPrice) + ' ' + lang.notAuthorizedPopup.text3}</p>
            <img className={style["not-authorized-popup__img"]} src={notAuthImg} alt="" title="" />
            <p>{lang.notAuthorizedPopup.text4}</p>
          </div>
          <button className={style['not-authorized-popup__button']} onClick={close}>
            {lang.notAuthorizedPopup.button}
          </button>
        </div>
      </div>
    </div>
  )
}